/* eslint-disable camelcase */
import { moment } from '@hotjar/insights-common/lib/moment';
import { FilterKindEnum } from '@hotjar/global-filters';
import { mapUserAttributeFilter } from '@hotjar/feedback/domain/common/UserAttributes/filterMappers/UserAttributeFilters';
import type { GlobalFilter } from '@hotjar/global-filters';
import type { Moment } from '@hotjar/insights-common/lib/moment';
import type { CountryCode } from '@hotjar/country-lib';
import type { Clause } from './Clause';

const clauseDateString = (date: Moment): string =>
  date.startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss');

export function convertFromNewUiToClause(currentValue: GlobalFilter): Clause[] {
  const clauses: Clause[] = [];

  if (currentValue.dateRange) {
    const dateFilter = currentValue.dateRange;

    if (dateFilter.type === 'absolute') {
      clauses.push({
        type: 'date_absolute',
        date_from: clauseDateString(moment(dateFilter.from)),
        date_to: clauseDateString(moment(dateFilter.to).add(1, 'days')),
      });
    } else if (dateFilter.type === 'relative') {
      clauses.push({
        type: 'date_relative',
        unit: dateFilter.unit,
        value: dateFilter.amount,
      });
    }
  }

  currentValue.filterList.forEach((filter) => {
    if (filter.value) {
      switch (filter.kind) {
        case FilterKindEnum.DeviceType: {
          clauses.push({ type: 'device', values: filter.value });
          break;
        }
        case FilterKindEnum.Country: {
          clauses.push({
            type: 'country',
            values: filter.value.selectedValues as CountryCode[],
            operation: filter.value.operation === 'IS_ANY_OF_THESE' ? 'EQUALS' : 'NOT_EQUALS',
          });

          break;
        }
        case FilterKindEnum.UserAttribute: {
          if (filter.value.value && filter.value.name) {
            clauses.push(mapUserAttributeFilter(filter.value));
          }
          break;
        }
      }
    }
  });

  return clauses;
}
